import styled from 'styled-components';
import {
  BaseListContainer,
  commonTableStyles
} from '../shared/SharedListStyles';

export const Container = styled(BaseListContainer)`
  width: 380px;
  min-width: 380px;
  max-width: 380px;
  padding-top: 5px;
  form > div {
    width: 350px;
  }
  .driver-list-table {
    ${commonTableStyles}
    button {
      padding-right: 0 !important;
      padding-left: 0 !important;
    }
  }
`;
